import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Planner from "./pages/planner";
import Home from "./pages/Start";
import LoadPlan from "./pages/loadplan"
import LoadCollection from "./pages/loadcollection"
import CreatePlan from "./pages/createPlan"
import { useEffect } from 'react';
import{gapi} from 'gapi-script';
import UserPlans from './pages/userplans';
import CreateUserPlan from './pages/createuserplan';
import SignIn from './pages/signIn';
function App() {
  const clientId = "379096657966-d3269c1fhvg1nun1qi3095lcfvqadn6b.apps.googleusercontent.com";
  useEffect(() => {
    const initClient = () => {
      gapi.client.init({
        clientId: clientId,
        scope: "",
      }).then(() => {
        // Initialization successful
        console.log('GAPI client initialized');
      }).catch((error) => {
        // Handle errors
        console.error('Error initializing GAPI client', error);
      });
    };

    gapi.load('client:auth2', initClient);
  }, []);
 

  return (
    <Router>
      <div>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/planner/:id" element={<Planner />} />
          <Route path = "/loadplan" element = {<LoadPlan/>}/>
          <Route path = "/loadcollection" element = {<LoadCollection/>}/>
          <Route path = "/newPlan" element = {<CreatePlan/>}/>
          <Route path = "/overview" element = {<UserPlans/>}/>
          <Route path = "/create/plan/user" element = {<CreateUserPlan/>}/>
          <Route path = "/signIn" element = {<SignIn/>}/>
        </Routes>
      </div>
    </Router>
  );
}

export default App;
